import React from "react";

export const GEO_META = {
    UK: { flag: "🇬🇧", label: "UK" },
    USA: { flag: "🇺🇸", label: "USA" },
    Europe: { flag: "🇪🇺", label: "Europe" },
    Worldwide: { flag: "🌍", label: "Worldwide" },
};

export const INTENSITY_META = {
    Documented: { label: "Documented", color: "text-[#56CCF2]", bg: "bg-[#56CCF2]/10 border-[#56CCF2]/40" },
    Emerging: { label: "Emerging", color: "text-[#2F80ED]", bg: "bg-[#2F80ED]/10 border-[#2F80ED]/40" },
    Wilder: { label: "Wilder", color: "text-[#F2C94C]", bg: "bg-[#F2C94C]/10 border-[#F2C94C]/40" },
    Extreme: { label: "Extreme", color: "text-[#EB5757]", bg: "bg-[#EB5757]/10 border-[#EB5757]/40" },
};

/**
 * Compact filter row used on Library, Master Timeline, Entities.
 * Calm, editorial. All chips lowercase-cap labels except geography flags.
 */
export function GeoChipRow({ value, options, onChange, dataTestId }) {
    return (
        <div className="flex flex-wrap gap-2" data-testid={dataTestId}>
            <button
                type="button"
                data-testid={`${dataTestId}-all`}
                onClick={() => onChange("")}
                className={`px-3.5 py-1.5 rounded-full text-[11px] uppercase tracking-wider font-medium transition-colors border ${!value ? "bg-[#2F80ED] text-white border-[#2F80ED]" : "bg-[#0B1220] text-[#94A3B8] border-[#243044] hover:border-[#2F80ED]"}`}
            >
                All regions
            </button>
            {options.map((o) => {
                const meta = GEO_META[o.value] || { flag: "", label: o.value };
                return (
                    <button
                        key={o.value}
                        type="button"
                        data-testid={`${dataTestId}-${o.value}`}
                        onClick={() => onChange(o.value)}
                        disabled={o.count === 0}
                        className={`px-3.5 py-1.5 rounded-full text-[11px] uppercase tracking-wider font-medium transition-colors border inline-flex items-center gap-1.5 ${value === o.value ? "bg-[#2F80ED] text-white border-[#2F80ED]" : o.count === 0 ? "bg-[#0B1220] text-[#3a455a] border-[#243044]/70 cursor-not-allowed" : "bg-[#0B1220] text-[#94A3B8] border-[#243044] hover:border-[#2F80ED]"}`}
                    >
                        <span className="text-sm leading-none">{meta.flag}</span>
                        {meta.label}
                        <span className="text-[10px] opacity-60">{o.count}</span>
                    </button>
                );
            })}
        </div>
    );
}

export function IntensityChipRow({ value, options, onChange, dataTestId }) {
    return (
        <div className="flex flex-wrap gap-2" data-testid={dataTestId}>
            <button
                type="button"
                data-testid={`${dataTestId}-all`}
                onClick={() => onChange("")}
                className={`px-3.5 py-1.5 rounded-full text-[11px] uppercase tracking-wider font-medium transition-colors border ${!value ? "bg-[#2F80ED] text-white border-[#2F80ED]" : "bg-[#0B1220] text-[#94A3B8] border-[#243044] hover:border-[#2F80ED]"}`}
            >
                All intensities
            </button>
            {options.map((o) => {
                const meta = INTENSITY_META[o.value] || { label: o.value, color: "text-[#94A3B8]", bg: "bg-[#0B1220] border-[#243044]" };
                const isActive = value === o.value;
                return (
                    <button
                        key={o.value}
                        type="button"
                        data-testid={`${dataTestId}-${o.value}`}
                        onClick={() => onChange(o.value)}
                        disabled={o.count === 0}
                        className={`px-3.5 py-1.5 rounded-full text-[11px] uppercase tracking-wider font-medium transition-colors border ${isActive ? "bg-[#2F80ED] text-white border-[#2F80ED]" : o.count === 0 ? "bg-[#0B1220] text-[#3a455a] border-[#243044]/70 cursor-not-allowed" : `bg-[#0B1220] ${meta.color} border-[#243044] hover:border-[#2F80ED]`}`}
                    >
                        {meta.label}
                        <span className="text-[10px] opacity-60 ml-1.5">{o.count}</span>
                    </button>
                );
            })}
        </div>
    );
}

/** Tiny inline badges used on TopicCard and Entity hub to surface geo/intensity at a glance. */
export function TagBadgeRow({ geography = [], intensity, compact = true }) {
    const meta = INTENSITY_META[intensity];
    return (
        <div className="flex flex-wrap items-center gap-1.5">
            {(geography || []).slice(0, 3).map((g) => {
                const m = GEO_META[g];
                if (!m) return null;
                return (
                    <span key={g} className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#0B1220] border border-[#243044] text-[10px] uppercase tracking-wider text-[#94A3B8]">
                        <span className="text-xs leading-none">{m.flag}</span>
                        {compact ? "" : m.label}
                    </span>
                );
            })}
            {meta && (
                <span className={`inline-flex items-center px-2 py-0.5 rounded-full border text-[10px] uppercase tracking-wider font-medium ${meta.bg} ${meta.color}`}>
                    {meta.label}
                </span>
            )}
        </div>
    );
}
